// import React from 'react';
// import { useFormik } from 'formik';
// import * as Yup from 'yup';
// import {
//   Box,
//   Button,
//   TextField,
//   Typography,
//   Grid,
// } from '@mui/material';
// import { useDispatch } from 'react-redux';
// import { useAppDispatch } from '../../../Redux Toolkit/Store';
// import { createOrder } from '../../../Redux Toolkit/Customer/OrderSlice';
// import { Address } from '../../../types/userTypes';

// // Validation schema
// const ContactSchema = Yup.object().shape({
//   name: Yup.string().required('Required'),
//   mobile: Yup.string()
//     .matches(/^[6-9]\d{9}$/, 'Invalid mobile number')
//     .required('Required'),
//   pinCode: Yup.string()
//     .matches(/^\d{6}$/, 'Invalid pincode')
//     .required('Required'),
//   address: Yup.string().required('Required'),
//   locality: Yup.string().required('Required'),
//   city: Yup.string().required('Required'),
//   state: Yup.string().required('Required'),
// });

// interface AddressFormProp {
//   handleClose: () => void;
//   paymentGateway:string
// }

// const AddressForm:React.FC<AddressFormProp> = ({handleClose,paymentGateway}) => {
//   const dispatch=useAppDispatch()
//   const formik = useFormik({
//     initialValues: {
//       name: '',
//       mobile: '',
//       pinCode: '',
//       address: '',
//       locality: '',
//       city: '',
//       state: '',
//     },
//     validationSchema: ContactSchema,
//     onSubmit: (values) => {
//       console.log("form submited", values);
//       handleCreateOrder(values as Address);
//       handleClose();
//     },
//   });

//   const handleCreateOrder=(address:Address)=>{
//     dispatch(createOrder({address,jwt:localStorage.getItem('jwt')|| "",paymentGateway}))
//   }

//   return (
//     <Box sx={{ maxWidth: 600, mx: 'auto'}}>
//       <p className='text-xl font-bold text-center pb-5'>
//         Contact Details
//       </p>
//       <form onSubmit={formik.handleSubmit}>
//         <Grid container spacing={3}>
//           <Grid item xs={12}>
//             <TextField
//               fullWidth
//               name="name"
//               label="Name"
//               value={formik.values.name}
//               onChange={formik.handleChange}
//               onBlur={formik.handleBlur}
//               error={formik.touched.name && Boolean(formik.errors.name)}
//               helperText={formik.touched.name && formik.errors.name}
//             />
//           </Grid>
//           <Grid item xs={6}>
//             <TextField
//               fullWidth
//               name="mobile"
//               label="Mobile"
//               value={formik.values.mobile}
//               onChange={formik.handleChange}
//               onBlur={formik.handleBlur}
//               error={formik.touched.mobile && Boolean(formik.errors.mobile)}
//               helperText={formik.touched.mobile && formik.errors.mobile}
//             />
//           </Grid>
//           <Grid item xs={6}>
//             <TextField
//               fullWidth
//               name="pinCode"
//               label="Pin Code"
//               value={formik.values.pinCode}
//               onChange={formik.handleChange}
//               onBlur={formik.handleBlur}
//               error={formik.touched.pinCode && Boolean(formik.errors.pinCode)}
//               helperText={formik.touched.pinCode && formik.errors.pinCode}
//             />
//           </Grid>
//           <Grid item xs={12}>
//             <TextField
//               fullWidth
//               name="address"
//               label="Address (House No, Building, Street)"
//               value={formik.values.address}
//               onChange={formik.handleChange}
//               onBlur={formik.handleBlur}
//               error={formik.touched.address && Boolean(formik.errors.address)}
//               helperText={formik.touched.address && formik.errors.address}
//             />
//           </Grid>
//           <Grid item xs={12}>
//             <TextField
//               fullWidth
//               name="locality"
//               label="Locality/Town"
//               value={formik.values.locality}
//               onChange={formik.handleChange}
//               onBlur={formik.handleBlur}
//               error={formik.touched.locality && Boolean(formik.errors.locality)}
//               helperText={formik.touched.locality && formik.errors.locality}
//             />
//           </Grid>
//           <Grid item xs={6}>
//             <TextField
//               fullWidth
//               name="city"
//               label="City"
//               value={formik.values.city}
//               onChange={formik.handleChange}
//               onBlur={formik.handleBlur}
//               error={formik.touched.city && Boolean(formik.errors.city)}
//               helperText={formik.touched.city && formik.errors.city}
//             />
//           </Grid>
//           <Grid item xs={6}>
//             <TextField
//               fullWidth
//               name="state"
//               label="State"
//               value={formik.values.state}
//               onChange={formik.handleChange}
//               onBlur={formik.handleBlur}
//               error={formik.touched.state && Boolean(formik.errors.state)}
//               helperText={formik.touched.state && formik.errors.state}
//             />
//           </Grid>
//           <Grid item xs={12}>
//             <Button sx={{py:"14px"}} type="submit" variant="contained" color="primary" fullWidth>
//               Add Address
//             </Button>
//           </Grid>
//         </Grid>
//       </form>
//     </Box>
//   );
// };

// export default AddressForm;


import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import {
  Box,
  Button,
  TextField,
  Typography,
  Grid,
} from '@mui/material';
import { useDispatch } from 'react-redux';
import { useAppDispatch } from '../../../Redux Toolkit/Store';
import { createOrder } from '../../../Redux Toolkit/Customer/OrderSlice';
import { Address } from '../../../types/userTypes';

// Validation schema
const ContactSchema = Yup.object().shape({
  name: Yup.string().required('Required'),
  mobile: Yup.string()
    .matches(/^[6-9]\d{9}$/, 'Invalid mobile number')
    .required('Required'),
  pinCode: Yup.string()
    .matches(/^\d{6}$/, 'Invalid pincode')
    .required('Required'),
  address: Yup.string().required('Required'),
  locality: Yup.string().required('Required'),
  city: Yup.string().required('Required'),
  state: Yup.string().required('Required'),
});

interface AddressFormProp {
  handleClose: () => void;
  paymentGateway: string;
}

const AddressForm: React.FC<AddressFormProp> = ({ handleClose, paymentGateway }) => {
  const dispatch = useAppDispatch();
  const [autoFilled, setAutoFilled] = useState(false);

  const formik = useFormik({
    initialValues: {
      name: '',
      mobile: '',
      pinCode: '',
      address: '',
      locality: '',
      city: '',
      state: '',
    },
    validationSchema: ContactSchema,
    onSubmit: (values) => {
      console.log("form submited", values);
      handleCreateOrder(values as Address);
      handleClose();
    },
  });

  const handleCreateOrder = (address: Address) => {
    dispatch(createOrder({ address, jwt: localStorage.getItem('jwt') || "", paymentGateway }))
  }

  // ✅ Auto-fill city and state based on pincode
  useEffect(() => {
    const fetchLocation = async () => {
      const pinCode = formik.values.pinCode;
      if (pinCode.length === 6) {
        try {
          const res = await fetch(`https://api.postalpincode.in/pincode/${pinCode}`);
          const data = await res.json();
          if (data[0].Status === 'Success') {
            const postOffice = data[0].PostOffice[0];
            formik.setFieldValue('city', postOffice.District);
            formik.setFieldValue('state', postOffice.State);
            setAutoFilled(true);
          } else {
            setAutoFilled(false);
          }
        } catch (error) {
          console.error("Error fetching city/state from pincode:", error);
          setAutoFilled(false);
        }
      } else {
        setAutoFilled(false);
      }
    };

    fetchLocation();
  }, [formik.values.pinCode]);

  return (
    <Box sx={{ maxWidth: 600, mx: 'auto' }}>
      <p className='text-xl font-bold text-center pb-5'>
        Contact Details
      </p>
      <form onSubmit={formik.handleSubmit}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              name="name"
              label="Name"
              value={formik.values.name}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.name && Boolean(formik.errors.name)}
              helperText={formik.touched.name && formik.errors.name}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              fullWidth
              name="mobile"
              label="Mobile"
              value={formik.values.mobile}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.mobile && Boolean(formik.errors.mobile)}
              helperText={formik.touched.mobile && formik.errors.mobile}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              fullWidth
              name="pinCode"
              label="Pin Code"
              value={formik.values.pinCode}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.pinCode && Boolean(formik.errors.pinCode)}
              helperText={formik.touched.pinCode && formik.errors.pinCode}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              name="address"
              label="Address (House No, Building, Street)"
              value={formik.values.address}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.address && Boolean(formik.errors.address)}
              helperText={formik.touched.address && formik.errors.address}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              name="locality"
              label="Locality/Town"
              value={formik.values.locality}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.locality && Boolean(formik.errors.locality)}
              helperText={formik.touched.locality && formik.errors.locality}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              fullWidth
              name="city"
              label="City"
              value={formik.values.city}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.city && Boolean(formik.errors.city)}
              helperText={formik.touched.city && formik.errors.city}
              disabled={autoFilled}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              fullWidth
              name="state"
              label="State"
              value={formik.values.state}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.state && Boolean(formik.errors.state)}
              helperText={formik.touched.state && formik.errors.state}
              disabled={autoFilled}
            />
          </Grid>
          <Grid item xs={12}>
            <Button sx={{ py: "14px" }} type="submit" variant="contained" color="primary" fullWidth>
              Add Address
            </Button>
          </Grid>
        </Grid>
      </form>
    </Box>
  );
};

export default AddressForm;
